export default __webpack_public_path__ + "static/media/rainy-4.9988edfd.svg";